module.exports = __webpack_public_path__ + "img/HH3.a1edd035.jpg";